<div class="container-fluid mt-3">
    <div class="row">
        <div class="col-sm-6">
            <div class="card">
                <div class="card-header"><strong>{{ 'kaitoriya.user_list' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="row mb-2">
                        <div class="col-md-3">
                            <wj-menu [(value)]="readonly" [isDisabled]="users.hasChanges()" [header]="'kaitoriya.edit_mode' | transloco">
                                <wj-menu-item [value]="true">{{ 'kaitoriya.lock' | transloco }}</wj-menu-item>
                                <wj-menu-item [value]="false">{{ 'kaitoriya.editable' | transloco }}</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div class="col-md-4"><span>{{ 'kaitoriya.hit_count' | transloco: {count: (users.totalCount | number)} }}</span></div>
                        <div class="col-md-5">
                            <button (click)="createUser()" class="btn btn-primary btn-block">{{ 'kaitoriya.create_new_user' | transloco }}</button>
                        </div>
                    </div>
                    <wj-flex-grid #grid [isReadOnly]="readonly" style="height:500px" [itemsSource]="users">
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'kaitoriya.name' | transloco" [binding]="'name'" [width]="150"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kaitoriya.email' | transloco" [binding]="'email'" [width]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kaitoriya.status' | transloco" [binding]="'status'" [width]="150"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kaitoriya.role' | transloco" [binding]="'roles'" [width]="'*'">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <span *ngFor="let role of cell.item.roles"> {{ role.name }} </span>
                            </ng-template>
                        </wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
                <div class="card-footer">
                    <div class="d-flex align-items-center flex-wrap">
                        <wj-menu [(value)]="users.pageSize" [header]="'kaitoriya.page_size' | transloco">
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                        </wj-menu>
                        <wj-collection-view-navigator class="ml-3" [cv]="users"></wj-collection-view-navigator>
                        <wj-collection-view-pager class="ml-3" [cv]="users"></wj-collection-view-pager>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <!-- 新規作成 -->
            <div class="card" *ngIf="isNew">
                <div class="card-header"><strong>{{ 'kaitoriya.user_create' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.username' | transloco }}</label>
                        <div class="col-md-9">
                            <input *ngIf="mode == 'edit'" type="text" class="form-control" [(ngModel)]="user.name" [placeholder]="'kaitoriya.username_placeholder' | transloco">
                            <span *ngIf="mode != 'edit'">{{ user.name }}</span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.email_address' | transloco }}</label>
                        <div class="col-md-9">
                            <input *ngIf="mode == 'edit'" type="email" class="form-control" [(ngModel)]="user.email" [ngModelOptions]="{standalone: true}" [placeholder]="'kaitoriya.email_optional' | transloco">
                            <span *ngIf="mode != 'edit'">{{ user.email }}</span>
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="mode == 'edit'">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.password' | transloco }}</label>
                        <div class="col-md-9">
                            <input type="password" class="form-control" [(ngModel)]="password" [placeholder]="'kaitoriya.password_placeholder' | transloco">
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="mode == 'edit'">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.password_confirm' | transloco }}</label>
                        <div class="col-md-9">
                            <input type="password" class="form-control" [(ngModel)]="confirmPassword" [placeholder]="'kaitoriya.password_confirm' | transloco">
                            <small class="text-danger" *ngIf="confirmPassword && password !== confirmPassword">{{ 'kaitoriya.password_mismatch' | transloco }}</small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.role' | transloco }}</label>
                        <div class="col-md-9">
                            <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedRoleName">
                                <option *ngFor="let role of assignableRoles" [value]="role.name">{{ role.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.status' | transloco }}</label>
                        <div class="col-md-9">
                            <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="user.status" [placeholder]="'kaitoriya.status' | transloco">
                                <option value="ACTIVE">{{ 'kaitoriya.active' | transloco }}</option>
                                <option value="SUSPENDED">{{ 'kaitoriya.suspended' | transloco }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-6" *ngIf="mode == 'edit'">
                            <button type="button" [disabled]="!createValid" class="btn btn-block btn-primary" (click)="confirmUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.confirm' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'edit'">
                            <button type="button" class="btn btn-block btn-danger" (click)="createUser()"><i class="fa fa-ban"></i> {{ 'kaitoriya.reset' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-success" (click)="saveUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.save' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-default" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.back' | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 編集 -->
            <div class="card" *ngIf="!isNew">
                <div class="card-header">
                    <strong *ngIf="mode == 'edit'">{{ 'kaitoriya.user_edit' | transloco }}</strong>
                    <strong *ngIf="mode != 'edit'">{{ 'kaitoriya.user' | transloco }}</strong>
                </div>
                <div class="card-body">
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.username' | transloco }}</label>
                        <div class="col-md-9">
                            <input *ngIf="mode == 'edit'" type="text" class="form-control" [(ngModel)]="user.name" [placeholder]="'kaitoriya.username_placeholder' | transloco">
                            <span *ngIf="mode != 'edit'">{{ user.name }}</span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.email_address' | transloco }}</label>
                        <div class="col-md-9">
                            <input *ngIf="mode == 'edit'" type="email" class="form-control" [(ngModel)]="user.email" [ngModelOptions]="{standalone: true}" [placeholder]="'kaitoriya.email_optional' | transloco">
                            <span *ngIf="mode != 'edit'">{{ user.email }}</span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.role' | transloco }}</label>
                        <div class="col-md-9">
                            <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedRoleName">
                                <option *ngFor="let role of assignableRoles" [value]="role.name">{{ role.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.status' | transloco }}</label>
                        <div class="col-md-9">
                            <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="user.status" [placeholder]="'kaitoriya.status' | transloco">
                                <option value="ACTIVE">{{ 'kaitoriya.active' | transloco }}</option>
                                <option value="SUSPENDED">{{ 'kaitoriya.suspended' | transloco }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-12" *ngIf="mode == 'edit'">
                            <button type="button" [disabled]="!editValid" class="btn btn-block btn-primary" (click)="confirmUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.confirm' | transloco }}</button>
                        </div>
                        <div class="col-sm-12" *ngIf="mode == 'view'">
                            <button type="button" class="btn btn-block btn-primary" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.edit' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-success" (click)="saveUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.save' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-default" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.back' | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- パスワード変更 -->
            <div class="card" *ngIf="!isNew && mode == 'edit'">
                <div class="card-header"><strong>{{ 'kaitoriya.change_password' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.password' | transloco }}</label>
                        <div class="col-md-9">
                            <input type="password" class="form-control" [(ngModel)]="newPassword" [placeholder]="'kaitoriya.password_placeholder' | transloco">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'kaitoriya.password_confirm' | transloco }}</label>
                        <div class="col-md-9">
                            <input type="password" class="form-control" [(ngModel)]="confirmNewPassword" [placeholder]="'kaitoriya.password_confirm' | transloco">
                            <small class="text-danger" *ngIf="confirmNewPassword && newPassword !== confirmNewPassword">{{ 'kaitoriya.password_mismatch' | transloco }}</small>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="col-sm-12">
                        <button type="button" [disabled]="!passwordValid" class="btn btn-block btn-primary" (click)="changePassword()"><i class="fa fa-dot-circle-o"></i> {{ 'kaitoriya.change' | transloco }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
